import { useMutation } from "@apollo/client";

import { SpeciesFormInputs } from "../../../components/SpeciesForm";
import { SettingsSpeciesCreateRoute_CreateDocument } from "../mutations.generated";

export default function useSettingsSpeciesCreateRoute_Create() {
    const [mutate, { data, loading, error }] = useMutation(SettingsSpeciesCreateRoute_CreateDocument);

    const createSpecies = (input: SpeciesFormInputs) => {
        return mutate({
            variables: {
                input,
            },
        });
    };

    return {
        createSpecies,
        loading,
        error,
        data: data?.settingsSpeciesCreate,
    };
}
